/* JT 4.0 global helpers: sheet/modal control, cart add + drawer refresh, sticky bar. */
(function () {
  'use strict';

  var openSheet = null;
  var overlay = null;

  function getOverlay() {
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'jt4-overlay';
      overlay.addEventListener('click', function () {
        if (openSheet) window.jt4.closeSheet(openSheet);
      });
      document.body.appendChild(overlay);
    }
    return overlay;
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openSheet) window.jt4.closeSheet(openSheet);
  });

  window.jt4 = {
    openSheet: function (el) {
      if (!el) return;
      if (openSheet && openSheet !== el) this.closeSheet(openSheet);
      getOverlay().classList.add('is-open');
      el.classList.add('is-open');
      el.removeAttribute('aria-hidden');
      document.body.classList.add('jt4-locked');
      openSheet = el;
      var focusable = el.querySelector('button, [href], input, select');
      if (focusable) focusable.focus({ preventScroll: true });
    },

    closeSheet: function (el) {
      if (!el) return;
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
      if (overlay) overlay.classList.remove('is-open');
      document.body.classList.remove('jt4-locked');
      if (openSheet === el) openSheet = null;
    },

    formatMoney: function (cents) {
      var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
      return '$' + amount;
    },

    /* Add a variant, refresh Dawn's cart drawer in place, slide it open. */
    addToCart: function (variantId, quantity, button) {
      var drawer = document.querySelector('cart-drawer');
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var fd = new FormData();
      fd.append('id', String(variantId));
      fd.append('quantity', String(quantity || 1));
      var sectionIds = null;
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        sectionIds = drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
        fd.append('sections', sectionIds);
        fd.append('sections_url', window.location.pathname);
      }
      if (button) {
        button.setAttribute('aria-disabled', 'true');
        button.classList.add('is-loading');
        button.dataset.jt4Label = button.textContent;
        button.textContent = 'Adding…';
      }
      function paint(state) {
        drawer.classList.remove('is-empty');
        var inner = drawer.querySelector('.drawer__inner');
        if (inner) inner.classList.remove('is-empty');
        drawer.renderContents(state);
      }
      return fetch(root + 'cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/javascript' } })
        .then(function (r) { return r.json(); })
        .then(function (state) {
          if (state.status && state.status !== 200) throw new Error(state.description || 'Could not add to cart');
          if (openSheet) window.jt4.closeSheet(openSheet);
          if (!(drawer && typeof drawer.renderContents === 'function')) {
            window.location.href = root + 'cart';
            return state;
          }
          if (state.sections) {
            paint(state);
            return state;
          }
          /* This store's cart/add.js does not bundle sections — fetch them. */
          return fetch(root + '?sections=' + sectionIds)
            .then(function (r) { return r.json(); })
            .then(function (sections) {
              paint({ sections: sections });
              return state;
            });
        })
        .catch(function (err) {
          console.error('[jt4] add to cart failed', err);
          window.location.href = root + 'cart';
        })
        .finally(function () {
          if (button) {
            button.removeAttribute('aria-disabled');
            button.classList.remove('is-loading');
            if (button.dataset.jt4Label) button.textContent = button.dataset.jt4Label;
          }
        });
    },

    /* Eased "swipe" scroll to an element, landing just under the sticky header. */
    scrollToEl: function (target, extraOffset) {
      if (!target) return;
      var header = document.querySelector('[data-jt4h]');
      var headerH = header ? header.getBoundingClientRect().height : 0;
      var offset = headerH + (typeof extraOffset === 'number' ? extraOffset : 16);
      var startY = window.pageYOffset;
      var endY = Math.max(0, target.getBoundingClientRect().top + startY - offset);
      var dist = endY - startY;
      if (Math.abs(dist) < 2) return 0;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        window.scrollTo(0, endY);
        return 0;
      }
      var duration = Math.min(1100, Math.max(520, Math.abs(dist) * 0.45));
      var start = null;
      var cancelled = false;
      function cancel() { cancelled = true; }
      window.addEventListener('wheel', cancel, { passive: true, once: true });
      window.addEventListener('touchstart', cancel, { passive: true, once: true });
      function ease(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
      var finished = false;
      function step(ts) {
        if (cancelled || finished) return;
        if (start === null) start = ts;
        var p = Math.min(1, (ts - start) / duration);
        window.scrollTo(0, startY + dist * ease(p));
        if (p < 1) window.requestAnimationFrame(step);
        else {
          finished = true;
          window.removeEventListener('wheel', cancel);
          window.removeEventListener('touchstart', cancel);
        }
      }
      window.requestAnimationFrame(step);
      /* If frames are throttled (background tab, low-power mode), still land on the target. */
      setTimeout(function () {
        if (finished || cancelled) return;
        finished = true;
        window.scrollTo(0, endY);
      }, duration + 400);
      return duration;
    },

    /* Quick blue pulse on an element (class `is-nudge`, styled by the section). */
    nudge: function (el, delay) {
      if (!el) return;
      setTimeout(function () {
        el.classList.remove('is-nudge');
        void el.offsetWidth;
        el.classList.add('is-nudge');
        setTimeout(function () { el.classList.remove('is-nudge'); }, 1800);
      }, delay || 0);
    },

    /* Show `bar` only when `anchor` has scrolled out of view above. */
    stickyBar: function (anchor, bar) {
      if (!anchor || !bar || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(
        function (entries) {
          var e = entries[0];
          var below = e.boundingClientRect.top < 0;
          bar.classList.toggle('is-shown', !e.isIntersecting && below);
        },
        { threshold: 0 }
      );
      io.observe(anchor);
    }
  };

  /* Section CTAs with no link of their own ("Pick your level", "Start training"...)
     glide to the product's level picker and pulse it, instead of jumping to the top. */
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var link = e.target.closest && e.target.closest('a');
    if (!link) return;
    var pd = document.querySelector('[data-jt4pd]');
    if (!pd) return;
    var href = link.getAttribute('href');
    if (href === null) href = '';
    if (href !== '' && href !== '#') {
      /* a same-page hash whose anchor doesn't exist here (e.g. "#shop" on a product
         page) would jump to the top, so send it to the picker instead */
      var u;
      try { u = new URL(href, window.location.href); } catch (err) { return; }
      if (u.origin !== window.location.origin || u.pathname !== window.location.pathname) return;
      if (u.hash.length < 2) return;
      var existing = null;
      try { existing = document.getElementById(decodeURIComponent(u.hash.slice(1))); } catch (err) {}
      if (existing) return;
    }
    var target = pd.querySelector('.jt4pd__optslabel') || pd.querySelector('[data-jt4pd-anchor]');
    if (!target) return;
    e.preventDefault();
    var stacked = window.matchMedia && window.matchMedia('(max-width: 989px)').matches;
    var offset = stacked ? Math.min(200, Math.round(window.innerHeight * 0.24)) : 20;
    var took = window.jt4.scrollToEl(target, offset) || 0;
    window.jt4.nudge(pd.querySelector('.jt4pd__opts') || pd.querySelector('[data-jt4pd-anchor]'), took + 120);
  });

  /* Same-page anchor links (e.g. "Shop now" -> #shop) glide instead of jumping. */
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var link = e.target.closest && e.target.closest('a[href*="#"]');
    if (!link || link.hasAttribute('data-no-glide') || link.classList.contains('skip-to-content-link')) return;
    var url;
    try { url = new URL(link.getAttribute('href'), window.location.href); } catch (err) { return; }
    if (url.origin !== window.location.origin || url.pathname !== window.location.pathname || url.hash.length < 2) return;
    var target;
    try { target = document.getElementById(decodeURIComponent(url.hash.slice(1))); } catch (err) { return; }
    if (!target) return;
    e.preventDefault();
    var drawer = link.closest('cart-drawer');
    if (drawer && typeof drawer.close === 'function') drawer.close();
    var took = window.jt4.scrollToEl(target, 0) || 0;
    var nudgeEl = target.hasAttribute('data-jt4-nudge') ? target : target.querySelector('[data-jt4-nudge]');
    if (nudgeEl) window.jt4.nudge(nudgeEl, took + 120);
    if (window.history && window.history.pushState) window.history.pushState(null, '', url.hash);
  });
})();
